import BackgroundSVG from 'app/assets/images/get-app/background.svg'
import PhoneImage from 'app/assets/images/get-app/phone.png'
import TabletImage from 'app/assets/images/get-app/tablet.png'
import Box from 'app/components/base/Box'
import Image from 'app/components/base/Image'
import Stack from 'app/components/base/Stack'
import { getStaticImageSrc } from 'app/utils/helpers/functions.helpers'

export const ImageSection = () => {
  return (
    <Stack
      direction="column"
      sx={{
        position: 'relative',
        display: { xs: 'none', md: 'flex' },
        height: 580
      }}
    >
      <BackgroundSVG />

      <Box
        sx={{
          position: 'absolute',
          bottom: -36,
          right: 55,
          width: 185,
          height: 367,
          zIndex: 2
        }}
      >
        <Image
          src={getStaticImageSrc(PhoneImage)}
          alt="phone"
          width={185}
          height={365}
          sizes="256px"
          placeholder="blur"
        />
      </Box>

      <Box
        sx={{
          position: 'absolute',
          width: 375,
          bottom: -14,
          left: -50,
          height: 522
        }}
      >
        <Image
          src={getStaticImageSrc(TabletImage)}
          alt="tablet"
          width={375}
          height={522}
          sizes="384px"
          placeholder="blur"
        />
      </Box>
    </Stack>
  )
}
